import { useApi } from "@/hooks/use-api";
import { LeaguesResponseApi } from "./get-leagues.types";

export const GetLeaguesApi = () => {
  const { data }: LeaguesResponseApi = useApi({
    path: `/v0/leagues?limit=100000&offset=0&is_b2b=true`,
    method: "get",
  });

  const leagues = data?._embedded?.leagues.map((item) => {
    return {
      id: item.id,
      name: item.name,
    };
  });

  return {
    data: leagues,
  };
};
